/**
 * @bos/portal3 — a tiny liveness pill in the footer. Calls the `health.ping` tRPC
 * procedure through the same-origin `/api` proxy on mount, proving the SPA reaches
 * @bos/portal3-server end to end. Degrades gracefully: the shell renders fine
 * whether the API is up, starting, or down.
 */
import { useEffect, useState } from 'react';
import { client } from '../rpc/client';

type Status = 'checking' | 'online' | 'offline';

export function ServerStatus() {
  const [status, setStatus] = useState<Status>('checking');

  useEffect(() => {
    let live = true;
    client.health.ping
      .query()
      .then(() => {
        if (live) setStatus('online');
      })
      .catch(() => {
        if (live) setStatus('offline');
      });
    return () => {
      live = false;
    };
  }, []);

  const label =
    status === 'checking' ? 'API: checking…' : status === 'online' ? 'API: online' : 'API: offline';

  return (
    <span className={`status status--${status}`} aria-live="polite">
      <span className="status__dot" aria-hidden="true" />
      {label}
    </span>
  );
}
